import { render, staticRenderFns } from "./liveShareTemp.vue?vue&type=template&id=620d74a1&scoped=true&"
import script from "./liveShareTemp.vue?vue&type=script&lang=js&"
export * from "./liveShareTemp.vue?vue&type=script&lang=js&"
import style0 from "./liveShareTemp.vue?vue&type=style&index=0&id=620d74a1&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "620d74a1",
  null
  
)

component.options.__file = "liveShareTemp.vue"
export default component.exports